module.exports = __webpack_public_path__ + "img/mz.157dee1c.svg";